import tw, { styled } from 'twin.macro';

export const UIBar = styled.div.attrs((props) => {
  className: props.className;
})(({ onClick }) => [
  tw`relative w-full flex items-center`,
  onClick && tw`cursor-pointer`
]);

export const UIBarGrowItem = styled.div(() => [tw`flex-grow`]);
